import type { AxiosInstance } from 'axios';
import type { PeticeAdresaDto } from '../generated';

export const addressLookupQuery = async <Params>(
	axiosInstance: AxiosInstance,
	params: Params
): Promise<PeticeAdresaDto[]> => {
	const { data } = await axiosInstance.get('/api/v1/adresy', { params });

	return data.seznam;
};
